import React from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import SbButton from '@Components/Button';
import RateSheetPreview, { ConvertApiResponse } from './RateSheetPreview';
import { exportRateSheetToExcel } from './exportRateSheetExcel';

interface RateSheetPreviewModalProps {
  open: boolean;
  onClose: () => void;
  data: ConvertApiResponse | null;
}

export const RateSheetPreviewModal: React.FC<RateSheetPreviewModalProps> = ({ open, onClose, data }) => {
  const theme = useTheme();

  if (!data) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      scroll="paper"
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1.5,
          borderBottom: '1px solid #EAECF0',
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Rate Sheet Preview
            </Typography>
            <Chip
              size="small"
              icon={
                <CheckCircleIcon
                  sx={{
                    fontSize: '16px !important',
                    color: `${theme.palette.success.main} !important`,
                  }}
                />
              }
              label="Converted Successfully"
              sx={{
                fontWeight: 600,
                fontSize: '0.75rem',
                backgroundColor: alpha(theme.palette.success.main, 0.1),
                color: theme.palette.success.main,
              }}
            />
          </Box>
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 0.5, display: 'block' }}>
            Previewing converted zones and rate slabs from your uploaded rate sheet
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" sx={{ color: theme.palette.text.secondary }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2.5, backgroundColor: alpha(theme.palette.primary.main, 0.01) }}>
        <RateSheetPreview data={data} />
      </DialogContent>

      <DialogActions
        sx={{ px: 3, py: 1.5, borderTop: '1px solid #EAECF0', display: 'flex', justifyContent: 'space-between' }}
      >
        <SbButton variant="outlined" startIcon={<DownloadIcon />} onClick={() => exportRateSheetToExcel(data)}>
          Download Excel Sheet
        </SbButton>
        <SbButton variant="contained" onClick={onClose}>
          Close
        </SbButton>
      </DialogActions>
    </Dialog>
  );
};

export default RateSheetPreviewModal;
